module.exports = __webpack_public_path__ + "img/6.bd158949.jpg";